<!-- 用户管理 PPuser-->
<template>
  <div class="ppuser">
    <div class="form_header">
      <el-form ref="form" :model="userform" inline>
        <div class="form_list">
          <el-form-item label="用户名称：" label-width="100px">
            <el-input v-model="userform.name"></el-input>
          </el-form-item>
          <el-form-item label="邮箱号码：" label-width="100px">
            <el-input v-model="userform.mailbox"></el-input>
          </el-form-item>
          <el-form-item label="国家：" label-width="60px">
            <el-select v-model="userform.country" filterable popper-class="dizhi" placeholder="Please Select">
              <el-option v-for="items in countryList" :key="items.id" :label="items.pinyin" :value="items.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司：" label-width="60px">
            <el-input v-model="userform.company"></el-input>
          </el-form-item>
          <el-form-item label="来源：">
            <el-select v-model="userform.platform" placeholder="请选择来源">
              <el-option label="pc" :value=1></el-option>
              <el-option label="无线" :value=2></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" icon="el-icon-upload2" @click="exportlist">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="username" label="用户名称" width="180"></el-table-column>
        <el-table-column prop="company" label="公司" width="180"></el-table-column>
        <el-table-column prop="country" label="国家" width="180">
          <template slot-scope="scope">
            <span>{{scope.row.country.pinyin}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
        <el-table-column prop="gift_count" label="礼品兑换次数"></el-table-column>
        <el-table-column prop="integral_count" label="积分领取次数"></el-table-column>
        <el-table-column prop="total_integral" label="可用积分"></el-table-column>
        <el-table-column prop="platform" label="来源" >
          <template slot-scope="scope">
            <span v-if="scope.row.platform==1">pc</span>
            <span v-if="scope.row.platform==2">无线</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="230">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="ckxq(scope.row)">详情</el-button>
            <el-button type="text" size="small" @click="hand(scope.row,3)">添加积分</el-button>
            <el-button type="text" size="small" @click="hand(scope.row,4)">减少积分</el-button>
            <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 详情 -->
    <el-dialog title="详情" :visible.sync="UserDetailsbox" @close="Noadd">
      <div class="user_details">
        <div class="user_two">
          <div class="name">用户名称</div>
          <div class="text">{{userli.username}}</div>
        </div>
        <div class="user_two">
          <div class="name">邮箱</div>
          <div class="text">{{userli.email}}</div>
        </div>
        <div class="user_two">
          <div class="name">头像</div>
          <div class="text">
            <!-- <img :src="userli.head_img" alt /> -->
            <el-image
            style="width: 200px;"
            :src="userli.head_img"
            fit="contain"
            :preview-src-list="userli.headList"></el-image>
          </div>
        </div>
        <div class="user_two">
          <div class="name">加入时间</div>
          <div class="text">{{filterTime(userli.created_at)}}</div>
        </div>
        <div class="user_two">
          <div class="name">来源</div>
          <div class="text">{{userli.platform == 1?'pc':userli.platform == 2?'无线':''}}</div>
        </div>
        <div class="user_two">
          <div class="name">选择日期</div>
          <div class="text">
            <el-date-picker v-model="recordDate" value-format="yyyy-MM" type="month" placeholder="选择日期" clearable @change="handelChangeTime"></el-date-picker>
          </div>
        </div>
        <div v-if="!delts">
          <el-tabs v-model="activeName" @tab-click="handleChange" lazy>
            <el-tab-pane label="积分领取" name="1">
              <el-table :data="userTableData" :header-cell-style="rowStyle" :cell-style="rowStyle" style="width: 100%" @row-click="rowclick">
                <el-table-column prop="order_id" label="订单"></el-table-column>
                <el-table-column prop="created_at" label="日期">
                  <template slot-scope="scope">
                    <span>{{filterTime(scope.row.created_at)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="积分">
                  <template slot-scope="scope">
                    <span>{{ scope.row.type == 4?'-':'+' }}</span><span>{{scope.row.num}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>
              </el-table>
              <div class="fy_box" style="margin-top:20px">
                <el-pagination @current-change="userfye" background prev-text="上一页" next-text="下一页" :current-page="userpage" :page-size="page_size" layout="total,prev, pager, next, jumper" :total="userTotal"></el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane label="礼品兑换" name="2">
              <el-table :data="userTableData" :header-cell-style="rowStyle" :cell-style="rowStyle" style="width: 100%" @row-click="rowclick">
                <el-table-column prop="order_id" label="订单"></el-table-column>
                <el-table-column prop="created_at" label="日期">
                  <template slot-scope="scope">
                    <span>{{filterTime(scope.row.created_at)}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="num" label="积分">
                  <template slot-scope="scope">
                    <span>-{{scope.row.num}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="remarks" label="备注"></el-table-column>
              </el-table>
              <div class="fy_box" style="margin-top:20px">
                <el-pagination @current-change="userfye" background prev-text="上一页" next-text="下一页" :current-page="userpage" :page-size="page_size" layout="total,prev, pager, next, jumper" :total="userTotal"></el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="tab_xqd" v-else>
          <div class="deta_cont" v-if="!ishand">
            <div class="rece_tit">
              <!-- <span>Details</span> -->
              <el-button type="primary" class="hui" @click="fanhui">返回</el-button>
            </div>
            <div class="detail_box">
              <div class="name">订单编号</div>
              <div class="title">{{detailsDa.order_id}}</div>
            </div>
            <div class="detail_box">
              <div class="name">产品线</div>
              <div class="title">{{detailsDa.products.name}}</div>
            </div>
            <div class="detail_box">
              <div class="name">产品系列</div>
              <div class="title">{{detailsDa.integral.model}}</div>
            </div>
            <div class="detail_box">
              <div class="name">序列号</div>
              <div class="title">{{detailsDa.serial_number}}</div>
            </div>
            <div class="detail_box">
              <div class="name">积分</div>
              <div class="title">{{detailsDa.integral.integral}}</div>
            </div>
            <div class="detail_box">
              <div class="name">安装地址</div>
              <div class="title">
                <span>{{detailsDa.country.pinyin}}</span>
                <span v-if="detailsDa.province!==''">{{detailsDa.province.pinyin}}</span>
                <span v-if="detailsDa.city!==''">{{detailsDa.city.pinyin}}</span>
                <span v-if="detailsDa.address!==''">{{detailsDa.address.pinyin}}</span>
              </div>
            </div>
            <div class="detail_box">
              <div class="name">时间</div>
              <div class="title">{{filterTime(detailsDa.created_at)}}</div>
            </div>
            <div class="detail_box">
              <div class="name">安装照片</div>
              <div class="title">
                <el-image v-for="item in detailsDa.aimgList" :key="item.index" style="width: 100px;" fit="contain" :src="item" :preview-src-list="detailsDa.aimgList"></el-image>
              </div>
            </div>
            <div class="detail_box">
              <div class="name">序列号照片</div>
              <div class="title">
                <el-image v-for="item in detailsDa.ximgList" :key="item.index" style="width: 100px;" fit="contain" :src="item" :preview-src-list="detailsDa.ximgList"></el-image>
              </div>
            </div>
          </div>
          <div class="deta_cont" v-else>
            <div class="rece_tit">
              <!-- <span>Details</span> -->
              <el-button type="primary" class="hui" @click="fanhui">返回</el-button>
            </div>
            <div class="detail_box">
              <div class="name">备注</div>
              <div class="title">{{detailsDa.remarks}}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="Noadd">关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 增减积分 -->
    <el-dialog :title="tithead" :visible.sync="handbox" @close="Noadd">
      <el-form :model="handform">
        <el-form-item label="积分数" label-width="80px">
          <el-input v-model="handform.num" autocomplete="off" placeholder="请输入积分数"></el-input>
        </el-form-item>
        <el-form-item label="备注" label-width="80px">
          <el-input v-model="handform.remarks" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="Noadd">取 消</el-button>
        <el-button type="primary" @click="quehand">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Switch } from 'element-ui';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  userlists,
  userdelete,
  excelexport,
  detailIntegral,
  hostimg,
  getCountry,
  detailIntegraladd
} from "../api/comm.js";
import { orderDetail } from '../api/system.js'
export default {
  //import引入的组件需要注入到对象中才能使用

  components: {},
  data() {
    //这里存放数据
    return {
      handbox: false,
      tithead: "增加",
      handId: "",
      handtype: "",
      handform: {
        num: "",
        remarks: ""
      },
      userform: {
        mailbox: "",
        name: "",
        company: "",
        country: "",
        platform: ""
      },
      userList: [
        {
          name: "王小虎",
          nickname: "大猫",
          province: "上海",
          mailbox: "1122@qq.com",
          integral: 1000,
          country: {
            name: ""
          }
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      Checklist: [],
      UserDetailsbox: false,
      userli: {},
      activeName: "1",
      recordDate: "",
      userpage: 1,
      page_size: 10,
      userTotal: 100,
      domainUrl: "",
      userTableData: [],
      countryList: [],
      delts: false,
      detailsDa:{},
      ishand: false,  //是否显示备注
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    fanhui(){
      this.delts = false;
      this.detailsDa = {};
    },
    countryStatus(row){
      switch(row.currency_id){
        case 1:
          return 'USA';
        case 2:
          return 'Britain';
        case 3:
          return 'Australian';  
      }
    },
    rowclick(row){
      console.log(row)
      if(row.type == 3 || row.type == 4) {
        this.delts = true;
        this.ishand = true;
        this.detailsDa.remarks = row.remarks;
        return;
      } 
      let data = {
        type: "1",
        order_id: row.order_id
      };
      orderDetail(data).then(res => {
        if (res.status_code == 200) {
          this.ishand = false;
          this.delts = true;
          this.detailsDa = res.data;
          this.detailsDa.aimgList = res.data.aimg.split(",");
          this.detailsDa.ximgList = res.data.ximg.split(",");
          this.detailsDa.aimgList.forEach((ele, i) => {
            this.detailsDa.aimgList[i] = this.domainUrl + ele;
          });
          this.detailsDa.ximgList.forEach((ele, i) => {
            this.detailsDa.ximgList[i] = this.domainUrl + ele;
          });
        }
      });
    },
    rowStyle() {
      return { textAlign: "center" };
    },
    // 国家列表--countryList
    getCountryS() {
      getCountry().then(res => {
        // console.log("国家", res);
        if (res.code == 200) {
          this.countryList = res.data;
        }
      });
    },
    //  时间换算
    filterTime(time) {
      var date = new Date(Number(time + "000"));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + s;
    },
    //实时域名
    domainName() {
      hostimg().then(res => {
        // console.log("实时域名", res);
        if (res.code == 200) {
          this.domainUrl = res.data.url;
        }
      });
    },
    //用户列表
    userdata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        email: this.userform.mailbox,
        username: this.userform.name,
        company: this.userform.company,
        country: this.userform.country,
        platform: this.userform.platform,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      userlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.userdata();
    },
    //搜索
    onSubmit() {
      // console.log(this.userform);
      this.currentindex = 1;
      this.userdata();
    },
    //取消搜索
    cancel() {
      this.userform.company = "";
      this.userform.country = "";
      this.userform.name = "";
      this.userform.mailbox = "";
      this.userform.platform= ""
      this.currentindex = 1;
      this.userdata();
    },
    //删除
    handleClick(e) {
      let data = {
        id: e.id
      };
      userdelete(data).then(res => {
        if (res.status_code == 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.userdata();
        }
      });
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
      this.Checklist = [];
      val.forEach(ele => {
        this.Checklist.push(ele.id);
      });

      // console.log(this.Checklist.join(","));
    },
    //导出
    exportlist() {
      let data = {
        ids: this.Checklist.toString(),
        type: "user",
        where: {}
      };
      if (this.userform.name == "" && this.userform.mailbox == "") {
        data.where = "";
      } else if (this.userform.name !== "") {
        data.where.username = this.userform.name;
      } else if (this.userform.mailbox !== "") {
        data.where.email = this.userform.mailbox;
      }
      excelexport(data).then(res => {
        console.log(res);
        const blob = new Blob([res]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "用户.xlsx"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    //详情
    ckxq(e) {
      // console.log(e);
      this.userli = e;
      this.userli.head_img = this.domainUrl + this.userli.head_img;
      this.userli.headList=[this.userli.head_img]
      this.UserDetailsbox = true;
      this.activeName = "1";
      this.userdes(this.activeName);
    },
    //时间切换
    handelChangeTime(e) {
      // console.log(e);
      // console.log(this.recordDate);
      this.userdes(this.activeName);
    },
    //切换
    handleChange(tab, event) {
      this.recordDate = "";
      this.userpage = 1
      this.userdes(this.activeName);
      console.log(this.activeName)
    },
    //用户兑换数据
    userdes(e) {
      let data = {
        page: this.userpage,
        page_size: this.page_size,
        user_id: this.userli.id,
        type: this.activeName,
        created_at: this.recordDate,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      detailIntegral(data).then(res => {
        console.log(res);
        if (res.status_code == 200) {
          this.userTableData = res.data.data;
          this.userTotal = res.data.total;
        }
      });
    },
    //弹窗分页
    userfye(val) {
      this.userpage = val;
      this.userdes();
    },
    Noadd() {
      // console.log(1);
      this.userli = {};
      this.userdata();
      this.UserDetailsbox = false;
      this.handbox = false;
      this.handform = {
        num: "",
        remarks: ""
      };
    },
    //手动弹窗
    hand(e, i) {
      // console.log(e);
      if (i == 3) {
        this.tithead = "增加";
      } else {
        this.tithead = "减少";
      }
      this.handtype = i;
      this.handbox = true;
      this.handId = e.id;
    },
    //提交积分
    quehand() {
      // console.log(this.handform);
      if (this.handform.num == "") {
        this.$message({
          type: "warning",
          message: "请输入积分数量"
        });
      } else if (this.handform.remarks == "") {
        this.$message({
          type: "warning",
          message: "请输入备注"
        });
      } else {
        let data = {
          user_id: this.handId,
          type: this.handtype,
          remarks: this.handform.remarks,
          num: this.handform.num,
          currency_id:parseInt(localStorage.getItem('countryId'))
        };
        detailIntegraladd(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.$message({
              type: "success",
              message: res.message
            });
            this.handtype = "";
            this.handbox = false;
            this.handId = "";
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getCountryS();
    this.domainName();
    this.userdata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.ppuser {
  padding: 20px 30px 0;
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    // padding: 20px 0;
    padding-bottom: 20px;
  }
  .user_details {
    .user_two {
      min-height: 45px;
      display: flex;
      align-items: center;
      .name {
        width: 80px;
        margin-right: 10px;
      }
      .text {
        img {
          width: 200px;
        }
      }
    }
  }
  .tab_xqd {
    margin-top: 25px;
    .detail_box {
      display: flex;
      align-items: center;
      min-height: 40px;
      .name {
        width: 180px;
        text-align: left;
      }
      .title {
        display: flex;
        span {
          margin-right: 10px;
        }
        img {
          width: 100px;
          margin-right: 10px;
          border: 1px solid #ccc;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.ppuser {
  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>